var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nav-item-branch"
  }, [_c('MdmLink', {
    staticClass: "item-link",
    class: "level-".concat(_vm.level),
    style: _vm.withColor && {
      color: _vm.item.color
    },
    attrs: {
      "id": _vm.buildUniqueIdName('NavItemBranch', "mdmLink".concat(_vm.item.id)),
      "url": _vm.item.url,
      "is-scramble-link": _vm.isScrambleLink,
      "is-prevent-default-link": true
    },
    domProps: {
      "textContent": _vm._s(_vm.item.label)
    },
    on: {
      "click": function click($event) {
        _vm.isOpen = true;
      }
    }
  }), _vm._v(" "), _c('NavItemTree', {
    ref: "tree",
    staticClass: "items-layer position-fixed",
    class: {
      'is-open': _vm.isOpen
    },
    attrs: {
      "is-menu-opened": _vm.isOpen,
      "is-scramble-link": _vm.isScrambleLink,
      "label": _vm.item.label,
      "type": _vm.item.type,
      "url": _vm.item.url,
      "items": _vm.item.items,
      "level": _vm.level + 1,
      "mea": _vm.item.mea
    },
    on: {
      "close": function close($event) {
        return _vm.close();
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };